<template>
  <div class="bookPracticeResult">
    <div class="topTitle">
      <div class="left" @click="$router.go(-1)">
        <van-image class="img" :src="require('@/assets/images/icon_backArrow_01.png')"></van-image>
      </div>
      <div class="center">成绩单</div>
      <div class="right">
      </div>
    </div>
    <div class="section">
      <!-- 分数开始 -->
      <div class="section_title">
        <van-image class="img" :src="require('@/assets/images/book/img_bg_04.png')" fit="cover"></van-image>
        <p class="text">您的分数为</p>
        <div class="fraction"><span class="big">{{ detail.answerScore }}</span>分</div>
      </div>
      <!-- 分数结束 -->

      <div class="section_content">
        <!-- 答题结果开始 -->
        <div class="box">
          <div class="box_left">
            <div class="box_item"
              v-for="(item, index) in list"
              :key="index"
            >
              <i :class="`icon icon_0${index+1}`"></i>
              <span>{{ item.text }}</span>
            </div>
          </div>
          <div class="box_right">
            共{{ detail.questions.length }}题
          </div>
        </div>
        <!-- 答题结果结束 -->

        <!-- 答题信息列表开始 -->
        <!-- <template v-for="(item, index) in detail.questions"> -->
          <div class="message" v-for="(item,index) in detail.questions" :key="item.id">
            <!-- 单选题开始 -->
              <div class="title" v-if="isShowTitle(item, detail.questions[index-1])">{{ dataText[item.type] }}</div>

              <div
                class="list_item"
                :class="`list_item${item.answerResult}`"
                @click="$router.push({name:'BookPractice',query:{behavior:'answer',id,isBack:1,answerPageNo:index+1}})"
              >

                <div class="eng">第{{ index + 1 }}题</div>
                <div class="text">查看解析</div>
              </div>
          </div>
            <!-- 单选题结束 -->

            <!-- 多选题开始 -->
            <!-- <div class="message" v-if="allArr[1].length">
              <div class="title">多选题</div>
              <ul class="list">
                <li
                  class="list_item"
                  :class="`list_item${item.answerResult}`"
                  v-for="(item, index) in allArr[1]"
                  :key="item.id"
                >
                  <div class="eng">第{{ allArr[0].length+index+1 }}题</div>
                  <div class="text">查看解析</div>
                </li>
              </ul>
            </div> -->
            <!-- 多选题结束 -->

            <!-- 判断题开始 -->
            <!-- <div class="message" v-if="allArr[2].length">
              <div class="title">判断题</div>
              <ul class="list">
                <li
                  class="list_item"
                  :class="`list_item${item.answerResult}`"
                  v-for="(item, index) in allArr[2]"
                  :key="item.id"
                >
                  <div class="eng">第{{ allArr[0].length+allArr[1].length+index+1 }}题</div>
                  <div class="text">查看解析</div>
                </li>
              </ul>
            </div> -->
            <!-- 判断题结束 -->

            <!-- 简答题开始 -->
            <!-- <div class="message" v-if="allArr[3].length">
              <div class="title">简答题</div>
              <ul class="list">
                <li
                  class="list_item"
                  :class="`list_item${item.answerResult}`"
                  v-for="(item, index) in allArr[3]"
                  :key="item.id"
                >
                  <div class="eng">第{{ allArr[0].length+allArr[1].length+allArr[2].length+index+1 }}题</div>
                  <div class="text">查看解析</div>
                </li>
              </ul>
            </div> -->
            <!-- 简答题结束 -->
        <!-- </template> -->
        <!-- 答题信息列表结束 -->

      </div>
    </div>
    <div class="fixed" @click="jumpTo">
      重做
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  components: {

  },
  data () {
    return {
      id: '',
      detail: {
        questions: []
      },
      list: [
        { text: '正确' },
        { text: '错误' }
      ],


      dataText: {
        1: '单选',
        2: '多选',
        4: '判断',
        5: '简答'
      }
    };
  },
  computed: {

  },
  watch: {

  },

  mounted () {
    const { $route: { query: { id } } } = this;

    this.id = id;
    this.getDetail();
  },
  methods: {

    /* 获取答题结果详情 */
    getDetail () {
      const { $http, id } = this;
      if (id) {
        $http.get('exercises/record', {
          params: {
            id
          }
        }).then(({ data }) => {
          this.detail = data || {};

          // const newArr1 = {
          //   1: {
          //     type: 1,
          //     answer: [] // newArr1[1].answer.length+1 = 5
          //   },
          //   2: {
          //     type: 2,
          //     answer: [] // 0  1  2  3
          //   },
          //   4: {
          //     type: 4,
          //     answer: []
          //   },
          //   5: {
          //     type: 5,
          //     answer: []
          //   }
          // };
          data.questions.sort(function (a, b) {return a.type - b.type;});
          // data.questions = data.questions.map((item) => {
          //   newArr1[item.type].answer.push(item);
          //   return item;
          // });
          this.detail = data;
          // console.log(newArr1);
        });
      }
    },

    /* 判断上一级与下一级的type值是否重复 */
    isShowTitle (item, item1) {
      return item1 ? item.type !== item1.type : true;
    },

    /* 重复按钮跳转 */
    jumpTo () {
      const { $router, id } = this;
      $router.push({ name: 'BookPractice', query: { isBack: 1, id, behavior: 'test' } });
    }
  }
};
</script>

<style scoped lang="less">
  .bookPracticeResult{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 10px);
    .topTitle{
      width: 100%;
      background: #FFFFFF;
      justify-content: space-between;
      padding: 16px 28px;
      align-items: center;
      display: flex;
      .left{
        .img{
          width: 29px;
          height: 29px;
        }
      }
      .center{
        flex: 1;
        text-align: center;
        font-size: 34px;
        font-weight: bold;
        color: #333444;
      }
      .right{
        .btn{
          width: 140px;
          height: 56px;
          background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
          border-radius: 8px;
          font-size: 24px;
          line-height: 56px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
    .section{
      padding: 50px 0px 20px;
      overflow-y: scroll;
      flex:1;
      .section_title{
        padding: 0 28px;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        border-bottom: 20px solid #F9FAFC;
        padding-bottom: 60px;
        margin-bottom: 40px;
        .img{
          width: 320px;
          height: 294px;
        }
        .text{
          font-size: 28px;
          line-height: 44px;
          color: #333333;
          margin-bottom: 30px;
        }
        .fraction{
          font-size: 24px;
          color: #FF485D;
          .big{
            font-size: 72px;
            font-weight: bold;
          }
        }
      }
      .section_content{
        padding: 0 28px;
        .box{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 36px 30px;
          width: 100%;
          background: #FFFFFF;
          box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
          border-radius: 16px;
          font-size: 28px;
          color: #333333;
          margin-bottom: 60px;
          .box_left{
            display: flex;
            align-items: center;
            .box_item{
              display: flex;
              align-items: center;
              margin-right: 30px;
              &:last-child{
                margin-right: 0;
              }
              .icon{
                display: inline-block;
                width: 44px;
                height: 44px;
                vertical-align: middle;
                border-radius: 50%;
                margin-right: 12px;
                &.icon_01{
                  background: #5FA9FF;
                  border: 4px solid #C1F1DF;
                }
                &.icon_02{
                  background: #FC485D;
                  border: 4px solid #FCB9BE;
                }
                &.icon_03{
                  background: #D8D8D8;
                  border: 4px solid #ECEAEA;
                }
              }
            }
          }
          .box_right{

          }
        }
        .message{
          margin-bottom: 30px;
          &:last-child{
            margin-bottom: 0;
          }
          .title{
            font-size: 32px;
            font-weight: bold;
            color: #333444;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            &::before{
              content: "";
              display: inline-block;
              width: 8px;
              height: 32px;
              background: #5FA9FF;
              border-radius: 4px;
              margin-right: 22px;
            }
          }
          .list_item{
            display: flex;
            align-items: center;
            padding: 24px 34px;
            position: relative;
            width: 100%;
            line-height: 78px;
            margin-bottom: 30px;
            height: 84px;
            background: #EFF6FF;
            border-radius: 8px;
            justify-content: space-between;
            &:last-child{
              margin-bottom: 0;
            }
            &.list_item2{
              .eng{
                color: #5FA9FF;
              }
              .text{
                color: #5FA9FF;
                &::after{
                  border-right: 2px solid #5FA9FF;
                  border-bottom: 2px solid #5FA9FF;
                }
              }
            }
            &.list_item0 , &.list_item1{
              background: #FFF7F8;
              border: 2px solid #FC485D;
              .text{
                color: #FC485D;
                &::after{
                  border-right: 2px solid #FC485D;
                  border-bottom: 2px solid #FC485D;
                }
              }
            }
            .eng{
              font-size: 26px;
              color: #67677A;
            }
            .text{
              font-size: 24px;
              display: flex;
              align-items: center;
              &::after{
                content: "";
                display: inline-block;
                transform: rotate(-45deg);
                width: 14px;
                height: 14px;
                margin-left: 22px;
              }
            }
          }
        }
      }
    }
    .fixed{
      width: 450px;
      height: 76px;
      border: 2px solid #5FA9FF;
      background: #fff;
      border-radius: 44px;
      font-size: 28px;
      line-height: 76px;
      color: #5FA9FF;
      text-align: center;
      margin: 16px auto;
    }
  }
</style>
